import type { ApiResponse, PaginatedResponse } from '@aigftpwatch/shared';

const BASE = import.meta.env.VITE_API_URL || '/api';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    ...options,
  });

  if (!res.ok) {
    const body = await res.json().catch(() => null);
    const message = body?.error?.message ?? `Request failed: ${res.status}`;
    throw new Error(message);
  }

  return res.json();
}

export const api = {
  get: <T>(path: string) => request<ApiResponse<T>>(path),
  getPaginated: <T>(path: string) => request<PaginatedResponse<T>>(path),
  post: <T>(path: string, body?: unknown) =>
    request<ApiResponse<T>>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  put: <T>(path: string, body?: unknown) =>
    request<ApiResponse<T>>(path, { method: 'PUT', body: body ? JSON.stringify(body) : undefined }),
  delete: <T>(path: string) => request<ApiResponse<T>>(path, { method: 'DELETE' }),
  getRaw: <T>(path: string) => request<T>(path),
};
